import * as Yup from 'yup';

const RecoverAccountSchema = Yup.object().shape({
    email: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
    emailConfirm: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
});

export default RecoverAccountSchema;
